import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cybersecurity01 from '../assets/our_solution/cyber_security01.png';
import cybersecurity02 from '../assets/our_solution/cyber_security02.png';
import digitalinfrastructure01 from '../assets/our_solution/digital_infrastructure01.png';
import digitalinfrastructure02 from '../assets/our_solution/digital_infrastructure02.png';
import telecom01 from '../assets/our_solution/telecom01.png';
import telecom02 from '../assets/our_solution/telecom02.png';
import workforce01 from '../assets/our_solution/workforce01.png';
import workforce02 from '../assets/our_solution/workforce02.png';
import digitalexperience01 from '../assets/our_solution/digital_experience01.png';
import digitalexperience02 from '../assets/our_solution/digital_experience02.png';
import brandexperience01 from '../assets/our_solution/brand_experience01.png';
import brandexperience02 from '../assets/our_solution/brand_experience02.png';
import omnichannel01 from '../assets/our_solution/omni_channel01.png';
import omnichannel02 from '../assets/our_solution/omni_channel02.png';
import { Container } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';

const accordionData = [
    {
        title: 'Cyber Security',
        content: [
            'Secure your cloud, data, and users with trusted security tools & solutions like Orca Security, Proofpoint, and EC-Council.',
            'We offer agentless cloud protection, data security, identity risk control, and compliance support all in one integrated ecosystem.'
        ],
        image1: cybersecurity01,
        image2: cybersecurity02,
        learnMoreLink: '/solutions-products#cyber-security',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Digital Infrastructure & Integration',
        content: [
            'Smart IT, built around your business.',
            'From infrastructure and hardware to AI-powered systems and custom development, we help you plan, build, and run tech that works end to end.'
        ],
        image1: digitalinfrastructure01,
        image2: digitalinfrastructure02,
        learnMoreLink: '/solutions-products#digital-infrastructure',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Telecom Innovation Stack',
        content: [
            'Driving digital innovation in telecom.',
            'We support leading telcos with mobile advertising, banking systems, and value added services to improve customer experience and boost performance.'
        ],
        image1: telecom01,
        image2: telecom02,
        learnMoreLink: '/solutions-products#telecom',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Workforce & Ops Management',
        content: [
            'Simplify workforce operations with smart, scalable tools.',
            'From talent systems to mobile dashboards, our solutions help you manage outsourced teams and field operations with ease.'
        ],
        image1: workforce01,
        image2: workforce02,
        learnMoreLink: '/solutions-products#workforce',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Digital Experience & Activation',
        content: [
            'Launch and scale your digital business faster.',
            'We provide catalog platforms, POS tools, and full commerce systems that help you streamline operations and drive sales online.'
        ],
        image1: digitalexperience01,
        image2: digitalexperience02,
        learnMoreLink: '/solutions-products#digital-experience',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Brand Experience & Activation',
        content: [
            'Engage your audience through experiences that stick.',
            'From events to digital campaigns, we turn ideas into action with tools and services for creative execution.'
        ],
        image1: brandexperience01,
        image2: brandexperience02,
        learnMoreLink: '/solutions-products#brand-experience',
        learnMoreText: 'Learn More'
    },
    {
        title: 'Omnichannel Media & Ads',
        content: [
            'Reach your market through every screen and platform.',
            'We offer multi-channel ad solutions from messaging and email to DOOH, radio, TV, and music content distribution.'
        ],
        image1: omnichannel01,
        image2: omnichannel02,
        learnMoreLink: '/solutions-products#omni-channel',
        learnMoreText: 'Learn More'
    },
];

export default function OurSolution() {
    const [activeKey, setActiveKey] = useState("0");

    const [fade, setFade] = useState(true);

    const handleSelect = (eventKey) => {
        if (eventKey !== null && eventKey !== activeKey) {
            setFade(false); // mulai fade out
            setTimeout(() => {
                setActiveKey(eventKey);
                setFade(true); // fade in setelah ganti gambar
            }, 100); // durasi fade out, sesuaikan dengan CSS
        }
    };

    return (
        <Container className="custom-stage">
            <h2 className="text-center title">Our Solutions</h2>
            <div className="text-center main-title" style={{ marginBottom: '20px' }}>
                <div className="responsive-title">Empowering Businesses Through</div>
                <div className="responsive-title">End-to-End Digital Orchestration</div>
            </div>
            <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                <div>
                    <p className="mb-3">
                        At Exel, we don't just deliver solutions. We design intelligent, interconnected digital ecosystems that help organizations operate smarter, scale faster, and engage deeper. Our approach blends cutting-edge cybersecurity, adaptive infrastructure, enterprise-grade integration, and experience-driven digital activation, all engineered to deliver tangible outcomes not just dashboards.
                    </p>

                    <p className="mb-3">
                        From multi-layered cloud protection to real-time audience engagement platforms, our services are crafted to support businesses at every level. Whether you’re optimizing operations, transforming customer journeys, or future-proofing your tech foundation.
                    </p>
                    <p className="mb-5">
                        This is more than IT support. This is digital transformation with measurable velocity, built around your ambition.
                    </p>
                </div>
            </AnimationOnScroll>

            <Row className="g-4 align-items-start">
                <Col md={8}>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__bounceIn" duration={.5} offset={100}>
                        <Accordion
                            defaultActiveKey="0"
                            activeKey={activeKey}
                            onSelect={handleSelect}

                        >
                            {accordionData.map((item, idx) => (
                                <Accordion.Item eventKey={idx.toString()} key={idx} className="mb-3">
                                    <Accordion.Header>{item.title}</Accordion.Header>
                                    <Accordion.Body>
                                        {Array.isArray(item.content)
                                            ? item.content.map((par, i) => <div key={i} className='accordion-paragraph' >{par}</div>)
                                            : <div className='accordion-paragraph'>{item.content}</div>
                                        }
                                        <a href={item.learnMoreLink} className="btn btn-primary" style={{ marginTop: '10px' }}>
                                            {item.learnMoreText}
                                        </a>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </AnimationOnScroll>
                </Col>
                <Col md={4} className="d-none d-md-flex flex-md-column gap-3 justify-content-center">
                    <div className={`fade-image ${fade ? 'show' : ''}`}>
                        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                            <img
                                src={accordionData[parseInt(activeKey)].image1}
                                alt={accordionData[parseInt(activeKey)].title}
                                style={{ maxWidth: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '10px' }}
                            />
                        </AnimationOnScroll>
                        <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                            <img
                                src={accordionData[parseInt(activeKey)].image2}
                                alt={accordionData[parseInt(activeKey)].title}
                                style={{ maxWidth: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                            />
                        </AnimationOnScroll>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}